// @flow
import classify from '@src/utils/typestyle';

const classes = classify({
  text: {
    marginTop: '12px',
    marginBottom: '13px',
    fontSize: '13px',
    lineHeight: '16px',
    textAlign: 'center',
    color: '#908e8e',
    fontWeight: 'bold'
  }
});

export default () => {
  return (
    <p className={classes.text}>Culet = small facet or point at the bottom of diamond pavilion.</p>
  );
};
